"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var _validate = require("@/utils/validate.js");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loadSubmit: false,
      visible: false,
      initLoading: false,
      detailInfo: {},
      refundAmtList: [
      // {typeName: '平台优惠', amt: 12, refundState: false, refundAmt: 0},
      {
        typeName: '卡券抵扣',
        amt: 0,
        refundState: false,
        refundAmt: 0
      }, {
        typeName: '现金支付',
        amt: 0,
        refundState: false,
        refundAmt: 0
      }],
      cashCardRequest: {
        couponId: [],
        // 卡券ID列表
        cash: 0,
        // 现金金额
        fuCard: [] // 福豆卡列表
      },
      buttonClicked: false // 新增标记，表示按钮已被点击
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    initOpen: function initOpen(aftersaleId) {
      var _this = this;
      if (!aftersaleId) return;
      this.visible = true;
      this.initLoading = true;
      this.detailInfo = {};
      this.cashCardRequest = {
        couponId: [],
        cash: 0,
        fuCard: []
      };
      this.buttonClicked = false; // 重置按钮状态
      aftersaleApi.getRefundAmt(aftersaleId).then(function (res) {
        var _ref = res || {},
          cash = _ref.cash,
          points = _ref.points,
          fuCard = _ref.fuCard,
          returnShopIntegralDesc = _ref.returnShopIntegralDesc;
        _this.detailInfo = _objectSpread(_objectSpread({}, res), {}, {
          id: aftersaleId
        });
        _this.initLoading = false;

        // 构建退款金额列表
        var refundAmtList = [{
          typeName: '福豆',
          amt: points,
          refundAmt: 0,
          refundState: false
        }].concat(_toConsumableArray(fuCard.map(function (card) {
          return {
            typeName: card.name,
            // 使用福豆卡的名称
            amt: card.amount,
            refundAmt: 0,
            refundState: false,
            submitIndex: "fuCard_".concat(card.fucardId) // 为每个fuCard生成唯一标识
          };
        })));
        _this.refundAmtList = [].concat(_toConsumableArray(refundAmtList), [{
          typeName: '现金支付',
          amt: cash,
          refundAmt: 0,
          refundState: false
        }]);
        if (returnShopIntegralDesc !== undefined && returnShopIntegralDesc !== null) {
          _this.refundAmtList.push({
            typeName: '积分抵扣',
            amt: returnShopIntegralDesc,
            refundAmt: 0,
            refundState: false,
            noSwitch: true
          });
        }
      }).catch(function (err) {
        _this.initLoading = false;
      });
    },
    // 开启金额时，自动填入默认金额
    changeSelect: function changeSelect(row) {
      var _ref2 = row || {},
        amt = _ref2.amt,
        refundState = _ref2.refundState,
        refundAmt = _ref2.refundAmt,
        submitIndex = _ref2.submitIndex;
      this.$set(row, 'refundAmt', refundState ? amt : 0);
    },
    // 按钮点击处理函数 - 立即响应UI变化
    onRefundClick: function onRefundClick() {
      // 已在处理中或按钮已被点击，阻止重复操作
      if (this.loadSubmit || this.buttonClicked) return;

      // 立即更新UI状态
      this.buttonClicked = true;

      // 执行实际的提交操作（防抖处理）
      this.processRefundSubmission();
    },
    // 实际的提交处理 - 应用防抖
    processRefundSubmission: (0, _validate.Debounce)(function () {
      var _this2 = this;
      // 如果已经在提交中，则不重复执行
      if (this.loadSubmit) return;
      var submitInfo = {};
      // 处理前重置请求对象
      this.cashCardRequest = {
        couponId: [],
        cash: 0,
        fuCard: []
      };
      var _ref3 = this.detailInfo && this.detailInfo.couponUseResponse || {},
        couponId = _ref3.couponId;
      this.refundAmtList.forEach(function (item) {
        var _ref4 = item || {},
          refundState = _ref4.refundState,
          refundAmt = _ref4.refundAmt,
          submitIndex = _ref4.submitIndex;
        if (refundState) {
          if (submitIndex && submitIndex.startsWith('fuCard_')) {
            // 如果是福豆卡，构建 FuCard 对象并添加到 cashCardRequest.fuCard
            var fuCardId = submitIndex.split('fuCard_')[1];
            var fuCard = _this2.refundAmtList.find(function (card) {
              return card.submitIndex === submitIndex;
            });
            if (fuCard) {
              _this2.cashCardRequest.fuCard.push({
                fucardId: parseInt(fuCardId),
                name: fuCard.typeName,
                amount: refundAmt
              });
            }
          } else if (submitIndex === 'couponId') {
            var _this2$cashCardReques;
            // 如果是卡券ID，添加到 cashCardRequest.couponId
            (_this2$cashCardReques = _this2.cashCardRequest.couponId).push.apply(_this2$cashCardReques, _toConsumableArray(couponId));
          } else {
            // 其他情况，直接设置 cashCardRequest.cash
            _this2.cashCardRequest.cash += refundAmt;
          }
        }
      });
      var hasRefundIntegralInfo = this.refundAmtList.some(function (item) {
        return item.typeName === '积分抵扣' && item.amt !== undefined && item.amt !== null && item.amt !== '';
      });
      if (!this.detailInfo.oneCardInstanceCardId && !hasRefundIntegralInfo && !this.cashCardRequest.couponId.length && !this.cashCardRequest.fuCard.length && this.cashCardRequest.cash === 0) {
        this.buttonClicked = false; // 重置按钮状态
        this.visible = false;
        return;
      }
      this.loadSubmit = true;
      aftersaleApi.submitRefundAmt(_objectSpread(_objectSpread({}, this.cashCardRequest), {}, {
        id: this.detailInfo.id
      })).then(function (res) {
        _this2.loadSubmit = false;
        // 成功后才恢复按钮状态 - 但通常成功后会关闭窗口
        _this2.$message.success('操作成功！');
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function (err) {
        _this2.loadSubmit = false;
        // 失败后也不恢复按钮状态，防止用户继续点击相同的错误操作
        _this2.$message.error('退款失败：' + (err.message || '未知错误'));
      });
    }, 800),
    // 设置800ms的防抖时间
    // 关闭弹窗时重置状态
    handleClose: function handleClose() {
      if (this.loadSubmit) return; // 如果正在提交，不允许关闭
      this.buttonClicked = false;
      this.visible = false;
    },
    getRefundStateText: function getRefundStateText(row) {
      if (!row || !row.noSwitch) {
        return '--';
      }
      if (row.typeName !== '积分抵扣') {
        return '--';
      }
      var amt = row.amt;
      if (amt === '该订单不可退积分') {
        return '--';
      }
      return '积分退款需要其他支付完全退款';
    }
  }
};